if (!customElements.get('peeko-commerce')) {
  customElements.define('peeko-commerce', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-variant-select]')) this.updateVariant(event.target.value);
      });
      this.addEventListener('submit', event => {
        if (this.getAttribute('aria-busy') === 'true' || !this.querySelector('[data-add-to-cart]') || this.querySelector('[data-add-to-cart]').disabled) event.preventDefault();
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async updateVariant(id) {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const previousQuantity = Number(this.querySelector('[name=quantity]')?.value || 1);
      this.setAttribute('aria-busy', 'true');
      const payment = this.querySelector('.pk-dynamic-checkout');
      if (payment) { payment.inert = true; payment.hidden = true; }
      const button = this.querySelector('[data-add-to-cart]');
      if (button) button.disabled = true;
      this.querySelector('.pk-commerce-error').hidden = true;
      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', id);
      url.searchParams.set('section_id', this.dataset.sectionId);
      // Preserve theme-template previews and Shopify preview context.
      const currentUrl = new URL(window.location.href);
      for (const key of ['view', 'preview_theme_id']) if (currentUrl.searchParams.has(key)) url.searchParams.set(key, currentUrl.searchParams.get(key));
      try {
        const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
        if (!response.ok) throw new Error('Variant request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = [...doc.querySelectorAll('peeko-commerce')].find(node => node.dataset.sectionId === this.dataset.sectionId);
        if (!next || next.dataset.variantId !== id) throw new Error('Variant unavailable');
        if (controller.signal.aborted) return;
        const nextMedia = doc.querySelector('[data-peeko-hero-media]');
        const currentMedia = this.closest('.pk-detail-top')?.querySelector('[data-peeko-hero-media]');
        if (nextMedia && currentMedia) currentMedia.replaceWith(nextMedia);
        currentUrl.searchParams.set('variant', id);
        window.history.replaceState({}, '', currentUrl);
        const quantity = next.querySelector('[name=quantity]');
        if (quantity && Number.isFinite(previousQuantity)) {
          const min = Number(quantity.min || 1), step = Number(quantity.step || 1);
          const max = quantity.max ? Number(quantity.max) : Infinity;
          const requested = Math.max(min, Math.min(previousQuantity, max));
          quantity.value = String(min + Math.floor((requested - min) / step) * step);
        }
        this.replaceWith(next);
        if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
        next.querySelector('[data-variant-select]')?.focus({preventScroll:true});
      } catch (error) {
        if (error.name === 'AbortError') return;
        // Never leave an old price or stock state paired with a newly selected variant.
        this.querySelector('[data-variant-select]').value = this.dataset.variantId;
        const message = this.querySelector('.pk-commerce-error');
        message.textContent = 'Unable to update this option. Please reload the page before adding to cart.';
        message.hidden = false;
      } finally {
        if (this.controller === controller) this.removeAttribute('aria-busy');
      }
    }
  });
}
